import { CIMSPage } from '@cims-online/shared'
import { Tooltip, Typography } from 'antd'
import { useUserDeleted } from 'hooks/useUserDeleted'
import ProjectLink from 'components/ProjectLink'
import type { SingleUserProps } from './types'

/**
 * Presents one project user as a profile link or as inactive text when the
 * user has been deleted.
 */
function SingleUser(user: SingleUserProps) {
  const isDeleted = useUserDeleted()
  if (isDeleted(user))
    return (
      <Tooltip title={user.displayName ? `${user.mail} (Inactive)` : undefined}>
        <Typography.Text delete>
          {user.displayName ?? user.mail}
        </Typography.Text>
      </Tooltip>
    )
  return (
    <ProjectLink item={CIMSPage.Users} deep={{ recordId: user.id }}>
      <Tooltip title={user.displayName ? user.mail : undefined}>
        {user.displayName ?? user.mail}
      </Tooltip>
    </ProjectLink>
  )
}

export default SingleUser
